import { PaymentTermType } from "../Constant";
var DATE_ONLY_REGEX = /^(\d{4})-(\d{2})-(\d{2})/;
export function normalizeToStartOfDay(d) {
    try {
        var out = new Date(d);
        out.setHours(0, 0, 0, 0);
        return out;
    }
    catch (_a) {
        return new Date();
    }
}
export function parseLocalDateOnly(value) {
    try {
        var s = String(value).trim();
        var dateOnly = DATE_ONLY_REGEX.exec(s);
        if (!dateOnly)
            return null;
        var y = parseInt(dateOnly[1], 10);
        var m = parseInt(dateOnly[2], 10) - 1;
        var d = parseInt(dateOnly[3], 10);
        var local = new Date(y, m, d);
        return isNaN(local.getTime()) ? null : normalizeToStartOfDay(local);
    }
    catch (_a) {
        return null;
    }
}
export function parseDateAsLocalOrNull(value) {
    try {
        if (value == null)
            return null;
        if (value instanceof Date)
            return isNaN(value.getTime()) ? null : normalizeToStartOfDay(value);
        var local = parseLocalDateOnly(value);
        if (local)
            return local;
        var d = new Date(value);
        return isNaN(d.getTime()) ? null : normalizeToStartOfDay(d);
    }
    catch (_a) {
        return null;
    }
}
/** Format date as yyyy-MM-dd for date input value. */
export function dateOnlyString(d) {
    try {
        if (!d || isNaN(d.getTime()))
            return "";
        return "".concat(d.getFullYear(), "-").concat(String(d.getMonth() + 1).padStart(2, "0"), "-").concat(String(d.getDate()).padStart(2, "0"));
    }
    catch (_a) {
        return "";
    }
}
/** Format date as MM/dd/yyyy for display. */
export function formatDateForDisplay(d) {
    try {
        if (!d || isNaN(d.getTime()))
            return "";
        return "".concat(String(d.getMonth() + 1).padStart(2, "0"), "/").concat(String(d.getDate()).padStart(2, "0"), "/").concat(d.getFullYear());
    }
    catch (_a) {
        return "";
    }
}
export function getInitialSelectedValue(iv) {
    try {
        if ((iv === null || iv === void 0 ? void 0 : iv.paymentTermType) === PaymentTermType.NET && (iv === null || iv === void 0 ? void 0 : iv.dueInDays) != null) {
            return "".concat(PaymentTermType.NET, "_").concat(iv.dueInDays);
        }
        return (iv === null || iv === void 0 ? void 0 : iv.paymentTermType) || PaymentTermType.RECEIPT;
    }
    catch (_a) {
        return PaymentTermType.RECEIPT;
    }
}
/** Selector: get PaymentTermsTemplates from Redux state. */
export function getPaymentTermsTemplatesFromRedux(state) {
    var _a, _b, _c;
    return (_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.salesRepData) === null || _a === void 0 ? void 0 : _a.baseData) === null || _b === void 0 ? void 0 : _b.PaymentTermsTemplates) !== null && _c !== void 0 ? _c : [];
}
